import { ChevronRight } from "lucide-react";

interface HeaderProps {
  title: string;
  subtitle?: string;
  onClose?: () => void;
  className?: string;
}

export function Header({ title, subtitle, onClose, className = '' }: HeaderProps) {
  return (
    <div onClick={onClose} className={`flex hover:cursor-pointer items-start justify-between gap-4 ${className || 'text-secondary'}`}>
      <div className="space-y-2 flex-1">
        <h2 className="text-2xl lg:text-3xl font-extrabold  leading-tight">{title}</h2>
        {subtitle && <p className="text-base">{subtitle}</p>}
      </div>
      {onClose && (
        <button
          className="p-2 hover:bg-secondary/5 rounded-lg transition-colors shrink-0 flex-shrink-0"
          title="Collapse"
        >
          <ChevronRight size={20} />
        </button>
      )}
    </div>
  );
}
